
















import { Vue, Component, Prop } from 'vue-property-decorator';
import {namespace} from "vuex-class";

import Maps from '@/views/components/Maps/Maps.vue';
import {IDefinePickup, IHub} from "@/models/StoreModels";
import {errorHandler} from "@/services/services";

const activeShipmentsModule = namespace('activeShipments');
const hubsModule = namespace("hubs");

@Component({
  name: 'SelectDestination',
  components: {
    Maps,
  },
})
export default class SelectDestination extends Vue {
  @Prop({ default: -1 })
  private asId!: number|string;

  @hubsModule.Getter("getHubList")
  private hubList!: IHub[];

  @activeShipmentsModule.Action('setPickupHub')
  private setPickupHub!: ({asId, hubId}: IDefinePickup) => Promise<any>;

  private loading: boolean = false;
  private myHub?: IHub;
  private errors: string = "";

  private updateSelectedHub(hub: IHub) {
    this.myHub = hub;
  }

  private goNextScreen() {
    // do something with the hub selected and then go home
    if (this.myHub && this.asId !== -1) {
      this.loading = true;
      this.setPickupHub({ asId: this.asId, hubId: this.myHub.id})
        .then(() => this.$uiBus.emit("dropup:close"))
        .catch(this.showErrors)
        .finally(() => this.loading = false);
    } else {
      this.$uiBus.emit("dropup:close");
    }
  }

  private showErrors(err: any) {
    errorHandler.handleErrorsResponse(err, 'selectDestination.errors');
  }

}
